import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

type Path = string | Array<string | number>;
type Validator = (validator: ValidatorFn) => ValidatorFn;

// TODO: Replace with ConditionalValidator from tools/validators
@Injectable()
export class ConditionalValidator {
  static when<T>(path: Path, predicate: (v: T) => boolean): Validator {
    return (validator: ValidatorFn) => (control: AbstractControl) => {
      if (!control.parent) { return null }

      const other = control.parent.get(path);
      if (predicate(other.value)) {
        return validator.call(this, control);
      }

      return null;
    };
  }

  static whenEq(path: Path, value: any): Validator {
    return this.when(path, (v) => v === value);
  }

  static whenNotEq(path: Path, value: any): Validator {
    return this.when(path, (v) => v !== value);
  }
}
